import { api } from './api-client';

export interface IceServerConfig {
  iceServers: RTCIceServer[];
  iceTransportPolicy?: RTCIceTransportPolicy;
}

export interface CallLogRow {
  id: string;
  callId: string;
  callerId: string;
  callerName: string | null;
  calleeId: string;
  calleeName: string | null;
  callType: 'AUDIO' | 'VIDEO';
  conversationId: string | null;
  startedAt: string;
  connectedAt: string | null;
  endedAt: string | null;
  durationSec: number | null;
  status: 'RINGING' | 'CONNECTED' | 'COMPLETED' | 'REJECTED' | 'MISSED' | 'NO_ANSWER' | 'FAILED';
  endReason: string | null;
}

export async function fetchIceServers(): Promise<IceServerConfig> {
  const { data } = await api.get<IceServerConfig>('/im/ice-servers');
  return data;
}

export async function fetchCallHistory(take = 50): Promise<CallLogRow[]> {
  const { data } = await api.get<CallLogRow[]>('/im/calls/history', { params: { take } });
  return data;
}
